import { prefersReducedMotion } from '../fx/motion';

const KEY = 'critter-clatter.fx-level';

export type FxLevel = 'full' | 'reduced';

let cached: FxLevel | null = null;

function readStored(): FxLevel {
  try {
    const raw = globalThis.localStorage?.getItem(KEY);
    if (raw === 'reduced' || raw === 'full') return raw;
  } catch {
    // A blocked store keeps the full look for this page.
  }
  return 'full';
}

export function fxLevel(): FxLevel {
  if (!cached) cached = readStored();
  return cached;
}

export function setFxLevel(level: FxLevel): void {
  cached = level;
  try {
    globalThis.localStorage?.setItem(KEY, level);
  } catch {
    // The choice still applies until the page reloads.
  }
}

export function toggleFxLevel(): FxLevel {
  const next: FxLevel = fxLevel() === 'full' ? 'reduced' : 'full';
  setFxLevel(next);
  return next;
}

/** Settings asked for a lighter board, or the device asked for less motion. */
export function effectsReduced(): boolean {
  return fxLevel() === 'reduced' || prefersReducedMotion();
}

/** Tests pin the level without touching storage. */
export function setFxLevelForTests(level: FxLevel | null): void {
  cached = level;
}
